import { render, staticRenderFns } from "./CompanyOvertimeCutOff.vue?vue&type=template&id=01fe64c1"
import script from "./CompanyOvertimeCutOff.vue?vue&type=script&lang=js"
export * from "./CompanyOvertimeCutOff.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports